/* Dreaming Plants — "Leggi di piu / Leggi meno" sulla descrizione prodotto.
   Il tema non ha nulla di simile: vp-show-more.js gestisce le liste di filtri,
   non un blocco di testo. Componente minimo, nessuna dipendenza.

   Il taglio a caratteri e gia deciso in Liquid: qui c'e solo l'apertura e la
   chiusura, con l'altezza reale del contenuto per avere una transizione
   fluida e nessun salto di layout. */
if (!customElements.get('dp-read-more')) {
  customElements.define(
    'dp-read-more',
    class DpReadMore extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector('[data-dp-text]');
        this.toggle = this.querySelector('[data-dp-toggle]');
        if (!this.text || !this.toggle) return;

        this.classList.add('is-collapsed');
        this.toggle.addEventListener('click', () => this.switch());
      }

      switch() {
        const aperto = this.classList.toggle('is-collapsed') === false;
        this.toggle.setAttribute('aria-expanded', String(aperto));
        this.toggle.textContent = aperto
          ? this.toggle.dataset.labelLess
          : this.toggle.dataset.labelMore;

        // chiudendo, riporto la vista in cima al testo se e uscita dallo schermo
        if (!aperto && this.getBoundingClientRect().top < 0) {
          this.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }
  );
}
